import { render, staticRenderFns } from "./HouseType.vue?vue&type=template&id=70377856&scoped=true"
import script from "./HouseType.vue?vue&type=script&lang=js"
export * from "./HouseType.vue?vue&type=script&lang=js"
import style0 from "./HouseType.vue?vue&type=style&index=0&id=70377856&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70377856",
  null
  
)

export default component.exports